skrilla.service('dota2ContestService', function($q, modalService){
    var objects = {};

    var getMatchIds = function(selectedMatches){
        return selectedMatches.map(function(match){
            return match.matchId ? match.matchId: match.id;
        }).filter(function(id){
            return id !== undefined;
        });
    }

    var confirmMatches = function(selectedMatches){
        var playerIds = [];
        var playerNames = {};
        selectedMatches.forEach(function(match){match.teams.forEach(
          function(team){team.members.forEach(function(member){
              playerIds.push(member.playerId);
              playerNames[member.playerId] = member.nickname + "(" + team.franchiseName + ")";
          })})
        });
        var idsCount = {};
        //count how many times each ID is represented
        playerIds.forEach(function(id){
            if(idsCount[id] != null){
                idsCount[id] ++;
            }else{
                idsCount[id] = 1;
            }
        });
        var usernameCount = " ";
        var count = idsCount[playerIds.pop()];
        var confirmed = true;
        for(var idCount in idsCount){
            var value = idsCount[idCount];
            if (value != count) {
                confirmed = false
            }
            usernameCount = usernameCount + "\r" +   playerNames[idCount] + ": " + value;
        }
        var confirmed = true;
        //check to see if all IDS aren't represented the same number of times
        if (!confirmed) {
            confirmed = confirm("Some players in this contest are overly represented!" + usernameCount)
        }
        return confirmed;
    }

    var openCreateModal = function(){
        modalService.openModal('/views/createDota2DailyContest/createDota2DailyContestModal.html', true, 'lg', false, false);
    }


    var openMatchesModal = function(){
        modalService.openModal('/views/matchesModal/matchesModal.html', true, 'lg', true, true);
    }

    var openPlaceholdersModal = function(){
        modalService.openModal('/views/matchPlaceholdersModal/matchPlaceholdersModal.html', true, 'lg', true, true);
    }
    

    var openActionModal = function(callback){
        return modalService.openModal('/views/actionDota2ContestModal/actionDota2ContestModal.html', true, 'lg', true, true, callback);
    }

    return {
        getMatchIds: getMatchIds,
        confirmMatches: confirmMatches,
        openMatchesModal: openMatchesModal,
        openCreateModal: openCreateModal,
        openActionModal: openActionModal,
        openPlaceholdersModal: openPlaceholdersModal
    };
});

